import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import compose from '../../hoc/compose';
import classNames from 'classnames';
import Tooltip from '../tooltip/tooltip';
import DropDown from '../dropDown/dropDown';
import DropDownIllustrationOption from '../dropDown/dropDownChildren/dropDownIllustrationOption';

// This is needed since there is TextFormatting.link component that passes dropdown value as boolean.
// Since dropdown doesn't support such type of values, we manually convert it to string
var convertDropDownValueToString = function convertDropDownValueToString(value) {
  return String(value);
};
function TextFormattingDropDown(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    tooltipContent = _ref.tooltipContent,
    shouldTranslate = _ref.shouldTranslate,
    options = _ref.options,
    hasArrowIcon = _ref.hasArrowIcon,
    callOnChangeAnyway = _ref.callOnChangeAnyway,
    getClassName = _ref.getClassName,
    optionsContainerClassName = _ref.optionsContainerClassName,
    disabled = _ref.disabled;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpened = _React$useState2[0],
    setIsOpened = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Tooltip, {
    disabled: !tooltipContent || isOpened,
    content: tooltipContent,
    isHint: true,
    shouldTranslate: shouldTranslate,
    closeOnContentMouseClick: true,
    closeOnMouseClick: true,
    closeOnMouseLeave: true
  }, /*#__PURE__*/React.createElement(DropDown, {
    illustrationOnly: true,
    value: convertDropDownValueToString(value),
    disabled: disabled,
    onChange: onChange,
    className: getClassName(classNames('text-formatting-dropdown', {
      'text-formatting-dropdown-opened': isOpened
    })),
    optionsContainerClassName: classNames('text-formatting-dropdown-options', optionsContainerClassName),
    onToggle: function onToggle(newIsOpened) {
      return setIsOpened(newIsOpened);
    },
    hasArrowIcon: hasArrowIcon,
    callOnChangeAnyway: callOnChangeAnyway,
    closeOnClickOutside: true
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(DropDownIllustrationOption, {
      value: convertDropDownValueToString(option.value),
      key: option.value
    }, /*#__PURE__*/React.createElement(Tooltip, {
      content: option.tooltipContent,
      isHint: true,
      disabled: !option.tooltipContent || !isOpened,
      alignment: "LEFT",
      marginLeft: 15,
      marginBottom: 2,
      closeOnContentMouseClick: true,
      closeOnMouseClick: true,
      closeOnMouseLeave: true
    }, option.content));
  })));
}
export default compose(TextFormattingDropDown);